import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-344f6e7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = {
  key: 0,
  class: "container-fluid"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-12 col-sm-12 d-flex gap-15 flex-column" }
const _hoisted_5 = { class: "w-100 d-flex justify-content-between gap-15 flex-md-row flex-column" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h3", { class: "d-flex align-items-end gap-5" }, [
  /*#__PURE__*/_createElementVNode("span", null, "Coverage Options"),
  /*#__PURE__*/_createElementVNode("span", { class: "tooltip-wrapper d-flex align-items-end" }, [
    /*#__PURE__*/_createElementVNode("i", { class: "iatse-icon-info-tooltip icon_rotate_0" }),
    /*#__PURE__*/_createElementVNode("p", { class: "tooltip-text tooltip-text_secondary tooltip-text__large tooltip-text__bottom" }, " please click the Benefits at a Glance button to the right to view all Plan C options. ")
  ])
], -1))
const _hoisted_7 = ["href"]
const _hoisted_8 = { class: "d-flex align-items-stretch flex-md-row flex-column flex-wrap mt-20 gap-10 flex-payment-option-cards" }
const _hoisted_9 = {
  key: 0,
  class: "capp-statement__toggle d-flex justify-content-center mb-30"
}
const _hoisted_10 = { class: "toggle-switch" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = ["onClick"]
const _hoisted_13 = { class: "capp-statement__details" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "capp-statement__owed rounded mt-15" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Amount Owed", -1))
const _hoisted_17 = { class: "capp-statement__action mt-30" }
const _hoisted_18 = ["onClick"]
const _hoisted_19 = {
  key: 0,
  class: "col capp-statement-item w-sm-100"
}
const _hoisted_20 = { class: "w-100 capp-statement capp-statement__mrp" }
const _hoisted_21 = { class: "capp-statement__details" }
const _hoisted_22 = { class: "capp-statement__owed rounded mt-15" }
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Amount Owed", -1))
const _hoisted_24 = { class: "capp-statement__action mt-30" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MessageCard = _resolveComponent("MessageCard")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_MessageCard, {
      message: "Select a coverage option, from the offerings below, by clicking the applicable box. Failure to make a selection will result in the Fund determining your enrollment for the upcoming quarter.",
      type: "primary",
      iconClass: "iatse-icon-alarm"
    }),
    _createElementVNode("div", _hoisted_1, [
      ($setup.dataLoaded)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _hoisted_6,
                  _createElementVNode("a", {
                    href: `${$setup.baseUrl}/storage/app/media/documents/Plan%20C%20Benefits%20at%20a%20Glance%20-%201-1-2025.pdf`,
                    target: "_blank",
                    class: "links"
                  }, "Benefit at a Glance", 8, _hoisted_7)
                ]),
                _createElementVNode("h5", null, [
                  _createTextVNode(" Your coverage selection and any applicable payment is due no later than "),
                  _createElementVNode("b", null, _toDisplayString($setup.dueDate), 1),
                  _createTextVNode(" for the coverage period starting "),
                  _createElementVNode("b", null, _toDisplayString($setup.coveragePeriod), 1)
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_8, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.groupedOptions, (planData, plan, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "capp-statement-item",
                  key: plan
                }, [
                  _createElementVNode("div", {
                    class: _normalizeClass(["capp-statement", `capp-statement__color-${(index % 5) + 1}`])
                  }, [
                    ($setup.hasFamilyAndSingle($setup.coverageOptions[plan]))
                      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                          _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("button", {
                              class: _normalizeClass({ active: !$setup.familyToggle[plan] }),
                              onClick: ($event: any) => ($setup.familyToggle[plan] = false)
                            }, " Single ", 10, _hoisted_11),
                            _createElementVNode("button", {
                              class: _normalizeClass({ active: $setup.familyToggle[plan] }),
                              onClick: ($event: any) => ($setup.familyToggle[plan] = true)
                            }, " Family ", 10, _hoisted_12)
                          ])
                        ]))
                      : _createCommentVNode("", true),
                    _createElementVNode("div", _hoisted_13, [
                      (planData?.current)
                        ? (_openBlock(), _createElementBlock("h3", _hoisted_14, _toDisplayString(planData.current.Title), 1))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_15, [
                        _hoisted_16,
                        _createElementVNode("h4", null, _toDisplayString($setup.formatCurrency(planData.current.AmountOwed)), 1)
                      ])
                    ]),
                    _createElementVNode("div", _hoisted_17, [
                      _createElementVNode("button", {
                        class: _normalizeClass(["btn btn-primary w-100", { 'btn-selected': $setup.isInvoiceSelected(planData.current.OptionKey) }]),
                        onClick: ($event: any) => ($setup.selectOption(plan, planData.current))
                      }, _toDisplayString(planData.current.IsCurrent
                                    ? 'Continue this coverage'
                                    : 'Select this coverage'), 11, _hoisted_18)
                    ])
                  ], 2)
                ]))
              }), 128)),
              ($setup.coverageOptions['MRP'])
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createElementVNode("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("h3", null, _toDisplayString($setup.coverageOptions['MRP'].Title), 1),
                        _createElementVNode("div", _hoisted_22, [
                          _hoisted_23,
                          _createElementVNode("h4", null, _toDisplayString($setup.formatCurrency($setup.coverageOptions['MRP'].AmountOwed)), 1)
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_24, [
                        _createElementVNode("button", {
                          class: _normalizeClass(["btn btn-primary w-100", { 'btn-selected': $setup.isInvoiceSelected($setup.coverageOptions['MRP'].OptionKey) }]),
                          onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.selectOption('MRP', $setup.coverageOptions['MRP'])))
                        }, [
                          ($setup.hasMrpDocuments)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString($setup.coverageOptions['MRP'].IsCurrent ? 'Continue this coverage' : 'Select this coverage'), 1))
                            : (_openBlock(), _createElementBlock("span", _hoisted_26, "Related Instructions"))
                        ], 2)
                      ])
                    ])
                  ]))
                : _createCommentVNode("", true)
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ], 64))
}